/* eslint-disable @typescript-eslint/no-empty-function */
import * as React from 'react';
import { darkTheme, lightTheme, ThemeProvider, useMediaQuery } from '../index';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { jsx as _jsx } from "react/jsx-runtime";
var MultiThemeContext = /*#__PURE__*/React.createContext({
  theme: 'light',
  setTheme: function setTheme() {}
});
export var useMultiTheme = function useMultiTheme() {
  var context = React.useContext(MultiThemeContext);

  if (context === undefined) {
    throw new Error('useMultiTheme must be used within a MultiThemeProvider');
  }

  return context;
};
export var MultiThemeProvider = function MultiThemeProvider(_ref) {
  var children = _ref.children,
      _ref$themes = _ref.themes,
      themes = _ref$themes === void 0 ? {
    light: lightTheme,
    dark: darkTheme
  } : _ref$themes;

  var _useLocalStorage = useLocalStorage('theme', 'system'),
      theme = _useLocalStorage[0],
      setTheme = _useLocalStorage[1];

  var prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
  var initialTheme = prefersDark ? 'dark' : 'light';
  var themeValue = themes[theme] || themes[initialTheme];
  return /*#__PURE__*/_jsx(MultiThemeContext.Provider, {
    value: {
      theme: theme,
      setTheme: setTheme
    },
    children: /*#__PURE__*/_jsx(ThemeProvider, {
      theme: themeValue,
      children: children
    })
  });
};